import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import clsx from 'clsx';

/**
 * ScrollPanel allows large blocks of content to become scrollable when their content reaches a defined length.
 * Scroll Panels do nothing by default but are activated by usage within a subset of components.
 * The length that the content needs to exceed is standardized and based upon the size of the Scroll Panel's parent context.
 * To use the component just wrap the desired scrollable content in a ScrollPanel.
 *
 */
function ScrollPanel(_ref) {
  let {
    children,
    className,
    ...rest
  } = _ref;
  const ref = useRef();
  const containerClassName = clsx({
    'scroll-panel': true
  }, className);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "scrollPanel",
    className: containerClassName,
    ref: ref
  }, rest), React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    ref
  })));
}
export default ScrollPanel;